export default __webpack_public_path__ + "static/Cashflow 101+202-6-544ee1e3e5f5175586ef4e4af5e25ce3.jpg";